// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Bloomberg';

export function BloombergLogo() {
  return (
    <svg
      width="100%"
      height="100%"
      version="1.1"
      viewBox="429.6 479.5 476.4 96.1"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      fill="currentColor"
      aria-label={TITLE}
      data-component="bloombergLogo"
    >
      <rect fill="none" x="429.5" y="479.5" width="480.2" height="100.2" />
      <path
        fill="currentColor"
        d="m442.1 491.9h10.4c9.5 0 13.6 3 13.6 9.1 0 5.3-4.2 8.9-12.5 8.9h-11.4v-18zm-12.5 59.7h25.4c13.3 0 26.7-4.8 26.7-20.1 0-9.1-6.4-16-15.2-17v-0.2c7.3-2.2 12.2-7.5 12.2-15.4 0-12.8-10.9-17.7-21.6-17.7h-27.5v70.4zm12.5-31h12c10.2 0 14.9 2.6 14.9 10 0 9.3-9 10.4-15.4 10.4h-11.5v-20.4z"
      />
      <path fill="currentColor" d="m489.8 479.5h11.9v72.1h-11.9v-72.1z" />
      <path
        fill="currentColor"
        d="m521.7 527.7c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.7 0.1-14-6.8-14-14.3zm-11.9 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.5 0.1-26 10.1-26 25.1z"
      />
      <path
        fill="currentColor"
        d="m579.1 527.7c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.8 0.1-14-6.8-14-14.3zm-12 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.4 0.1-26 10.1-26 25.1z"
      />
      <path
        fill="currentColor"
        d="m626.4 503.9h11.3v7.5h0.2c2.1-4.5 6.7-8.7 14.6-8.7 7.4 0 12.4 2.9 14.9 8.9 3.5-6.1 8.6-8.9 15.7-8.9 12.7 0 17.2 9.1 17.2 20.5v28.5h-11.9v-27.1c0-6-1.8-11.1-8.9-11.1-7.5 0-10.3 6.2-10.3 12.3v25.9h-11.9v-28.5c0-5.9-2.4-9.8-8.2-9.8-7.9 0-10.9 5.8-10.9 12.1v26.1h-11.9v-47.7z"
      />
      <path
        fill="currentColor"
        d="m749.7 527.7c0 7.5-5.3 14.3-14 14.3-8.8 0-14-6.9-14-14.3 0-7.5 5.3-14.3 14-14.3s14 6.9 14 14.3zm-39.6 23.9h11.3v-7.2h0.2c3.5 5.8 9.8 8.4 16.4 8.4 14.7 0 23.6-10.9 23.6-25.1 0-14.1-9.5-25.1-23.1-25.1-9 0-13.7 4.2-16.2 7.3h-0.3v-30.4h-11.9v72.1z"
      />
      <path
        fill="currentColor"
        d="m779 523c0.9-6.9 5.3-11.3 12.3-11.3 7.5 0 12 4.4 12.1 11.3h-24.4zm36.4 8.9v-3.3c0-16.6-9.1-26-22.4-26-14.4 0-26 10.1-26 25.1s11.5 25.1 26 25.1c7.6 0 14.6-2.7 20.2-9.6l-8.6-6.5c-3 3.7-6.9 6.5-12.8 6.5-6.7 0-12-4.3-12.8-11.3h36.4z"
      />
      <path
        fill="currentColor"
        d="m823.2 503.9h11.9v7.6h0.2c2.6-5.5 7.9-8.8 14.1-8.8 1.5 0 2.9 0.3 4.3 0.7v11.5c-2-0.5-3.9-0.9-5.8-0.9-11.2 0-12.8 9.5-12.8 12v25.6h-11.9v-47.7z"
      />
      <path
        fill="currentColor"
        d="m880.5 513.4c8.7 0 14.1 5.8 14.1 14 0 8-5.4 14-14.2 14-8.1 0-14-6.3-14-13.8 0-8.4 5.7-14.2 14.1-14.2zm14.1-9.5v7.2h-0.2c-3.5-5.8-9.8-8.4-16.4-8.4-14.7 0-23.6 11-23.6 25.1 0 13.5 9.5 24.5 23.8 24.5 6 0 12.1-2.3 15.6-7h0.2v3.5c0 9.5-3.6 16-15.1 16-6.7 0-11.6-2.5-16.4-6.9l-7.2 9.8c6.8 6 14.8 7.9 23.7 7.9 18.6 0 27-10.9 27-28.2v-43.5h-11.4z"
      />
    </svg>
  );
}
